module.exports = function getResource(label, vars = []) {
    const resources = {
        addGiftMessage: 'Ajouter un message',
        new: 'Nouveauté'
    };

    return resources[label];
};
